import swiperUtil from '../utils/swiper-util';

export default (node) => {
  const swiperNode = node.querySelector('[data-swiper]');
  const buttonNext = node.querySelector('[data-next]');
  const buttonPrev = node.querySelector('[data-prev]');
  const paginationNode = node.querySelector('[data-swiper-pagination]');

  const initSwiper = () => {
    swiperUtil(swiperNode, {
      spaceBetween: 24,
      slidesPerView: 1.2,
      centeredSlides: true,
      initialSlide: 0,
      loop: true,
      navigation: {
        nextEl: buttonNext,
        prevEl: buttonPrev,
      },
      pagination: {
        el: paginationNode,
        clickable: true,
        renderBullet: function (index, className) {
          return `
          <span class="${className} block w-10 h-[1px] mx-1 bg-control-inactive-primary"></span>
          `;
        },
      },
      breakpoints: {
        768: {
          slidesPerView: 1.5,
          spaceBetween: 24,
        },
        1024: {
          slidesPerView: 2.0,
          spaceBetween: 24,
        },
        1366: {
          slidesPerView: 1.7,
          spaceBetween: 24,
        },
        1679: {
          slidesPerView: 2,
          spaceBetween: 24,
        },
      },
    });
  };

  if (swiperNode) initSwiper();
};
